#clear-button {
    color: white;
}

body {
    touch-action: none;
}

.e-small-icon::before {
    content: "\e997";
}

.e-medium-icon::before {
    content: "\e94c";
}

.e-big-icon::before {
    content: "\e74c";
}

.e-view {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}

.sb-left {
    float: left;
}

.sb-right {
    float: right;
}

.sb-block {
    display: block;
}

.sb-table {
    display: table;
}

.sb-table-cell {
    display: table-cell;
    vertical-align: middle;
}

.sb-header {
    height: 48px;
    background: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    z-index: 1001;
    opacity: 100;
}

.sb-header-left,
.sb-header-right {
    height: 100%;
}

#sb-header-text {
    padding-left: 22px;
    opacity: 0.87;
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
    color: #000000;
    text-align: left;
}

.sb-header-splitter {
    float: left;
    border-left: 1px solid rgb(196, 196, 196);
    height: 32px;
    margin-top: 8px;
    padding-left: 22 px;
}

.sb-header-settings {
    display: none;
}

.product-style a {
    padding-right: 15px;
    font-family: Roboto;
    font-weight: 500;
    font-size: 13px;
    color: #363636;
    text-align: center;
    text-decoration: none;
}

.product-style a:hover {
    color: #3c78ef;
}

.sb-download-btn a {
    text-decoration: none;
}

.sb-download-text {
    color: #ffffff;
}

.sb-download-wrapper {
    padding-right: 27px;
}

.sb-download-btn:hover .sb-download-btn:focus .sb-download-btn.active {
    border-radius: 2px;
    font-family: "Roboto";
    font-weight: bold;
    color: #ffffff;
}

.sb-download-btn:hover {
    background: #006ce6;
}

.sb-download-btn:focus {
    background: #0051cb;
}

.sb-download-btn.active {
    background: #0036b1;
}

.sb-download-btn {
    background-color: #3c78ef;
    opacity: 100;
    border-radius: 2px;
    font-family: "Roboto", "sans-serif";
    font-weight: 500;
    line-height: 18px;
    height: 32px;
    border-color: transparent;
}

.sb-bread-crumb {
    padding-left: 20px;
    padding-top: 24px;
    padding-bottom: 10px;
}

.category-allcontrols a,
.category-text a,
.crumb-sample {
    display: table;
    opacity: 0.87;
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
    color: #3c78ef;
    text-align: left;
    text-decoration: none;
}

.sb-bread-crumb .sb-bread-crumb-text>div {
    font-size: 15px;
    font-weight: 500;
    padding-right: 8px;
    cursor: default;
    display: table-cell;
}

.sb-bread-crumb-text>div.seperator {
    font-weight: 700;
    font-size: 15px;
    vertical-align: bottom;
}

.content {
    overflow: auto;
    height: calc(100% - 50px);
    top: 550px;
}

.sample-content {
    top: 48px;
    background: #ffffff;
}

.div {
    display: block;
}

.control-section {
    padding-left: 4px;
    margin: 12px 0;
}

.crumb-sample {
    color: #000000;
    line-height: 18px;
}

#description {
    padding-bottom: 16px;
    padding-left: 20px;
    opacity: 0.75;
    font-family: Roboto;
    font-size: 13px;
    color: #000000;
    text-align: left;
    padding-top: 14px;
}

#action-description {
    padding-left: 20px;
    padding-bottom: 15px;
    font-family: Roboto;
    font-size: 13px;
    color: #000000;
    text-align: left;
}

#description-section {
    padding-left: 20px;
    padding-top: 30px;
    opacity: 0.87;
    font-family: Roboto;
    font-weight: 700;
    font-size: 15px;
    color: #000000;
    text-align: left;
}

.layout {
    display: inline-block;
    cursor: pointer;
}

#actionDes {
    opacity: 0.75;
}

.test-hover-map div {
    display: none;
}

.test-hover-map:hover div {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}

.map-tooltip {
    display: none;
}

.map-tooltip.is-visible {
    display: block;
    position: absolute;
    background: white;
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.36);
    padding: 15px;
    color: black;
    border-radius: 3px;
}

.e-rowcell {
    position: relative;
}

/* .chip {
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    font-family: "Roboto";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    text-align: center;
} */


.filter-chip {
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    font-family: "Roboto";
    width: 100px;
    margin-left: 10px;
    text-align: center;
}

.chipWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.chip {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    float: left;
    margin: 0 0.5rem 0 0;
    border: 2px solid white;
    box-shadow: 2px 2px 3px 0 RGBA(0, 0, 0, 0.5);
    text-align: center;
    vertical-align: middle;
    font-weight: 600;
    line-height: 1.9rem;
}

.negativeReponseTableChip{
    width: 50px;
    height: 30px;
    color: white;
}

.positiveChip {
    background: #2ba259;
}

.neutralChip {
    background: #7b7b7a;
}

.negativeChip {
    background: #ef3b42;
}

.--chip {
    background: #e6e4e4;
    color: #a3a1a1;
}

.lozenge {
    text-transform:uppercase;
    padding: 0.2rem 0.6rem;
    color:white;
    width: fit-content;
    border-radius:2rem;
    border: 2px solid white;
    box-shadow: 2px 2px 3px 0 RGBA(0, 0, 0, 0.5);
}

.fail-lozenge {
    background-color:#ef3b41; 
    padding: 0.2rem 0.8rem;
}

.pass-lozenge {
    background-color:#2ba259; 
}

.moodText {
    padding-left: 10px;
}

.mdl-grid,
.e-card .e-card-content {
    padding: 0 !important;
}

#date-grid .e-groupdroparea {
    font-weight: 300;
    background-color: white !important;
    min-height: 64px !important;
    border: 0 white !important;
    color: rgba(0, 0, 0, 0.5) !important;
    font-weight: normal !important;
}

#date-grid.e-grid {
    border: 0 white !important;
}

/* body {
    background: #f5f5f5;
} */



.e-grid {
    border: none;
}

.e-card {
    box-shadow: 0 2px 32px 0 rgba(0, 0, 0, 0.16) !important;
    border-radius: 4px;
    overflow: hidden;
}

.e-btn.e-flat.e-primary,
.e-css.e-btn.e-flat.e-primary {
    color: #E3165C !important;
}

.e-btn.e-flat,
.e-css.e-btn.e-flat {
    color: rgba(0, 0, 0, 0.87) !important;
}

#date-range {
    top: 0;
    left: 10px;
    z-index: 999;
    height: 60px;
    width: 240px;
    margin: 0.5rem 1rem;
    padding: 1rem 0.5rem 0;
}

.e-grid .e-headercelldiv {
    font-size: 13px;
    font-weight: 500;
}

.e-grid .e-rowcell {
    color: #444444;
}

.e-grid .e-gridheader {
    color: #555;
}

.e-toolbar .e-toolbar-items {
    min-height: 47px;
}

#Grid-searchbar,
.e-search input {
    font-size: 14px !important;
    padding-bottom: 4px !important;
}

#daterangepicker{
    font-size: 14px !important;
    color: #393939 !important;
}

.e-daterangepicker.e-popup .e-presets, .e-bigger.e-small .e-daterangepicker.e-popup .e-presets {
    max-height: 305px !important;
}

.e-daterangepicker.e-popup .e-footer:after {
    content: "Max Three Month Range";
    margin-right: 8rem;
    color: #e3165b;
}

.e-input-group.e-search {
    margin-top: 6px;
    margin-right: 10px;
}

.e-search-icon {
    top: 3px;
}

.e-search-icon:before {
    font-size: 15px;
}

.e-grid .e-columnmenu:before,
.e-grid-menu .e-columnmenu:before {
    font-size: 13px;
}

.e-grid .e-groupdroparea.e-grouped {
    background: transparent;
}

.e-grid .e-columnmenu {
    margin: 3px;
    padding: 0px;
}

#loader {
    font-family: "Helvetica Neue", "calibiri";
    font-size: 14px;
    height: 40px;
    left: 45%;
    position: absolute;
    top: 25%;
    width: 30%;
}

.wrap {
    margin: 0 auto;
    width: 240px;
}

h5 {
    font-weight: bold;
    text-align: center;
}

#Grid_content_table {
    min-height: 210px;
}

.e-spinner-pane .e-spinner-inner {
    background-color: white;
    border-radius: 40px;
    padding: 15px;
    box-shadow: 10px 10px 21px -5px rgba(0, 0, 0, 0.33);
}

.e-grid .e-emptyrow td {
    text-align: center !important;
}

.awaiting {
    font-size: 30px;
    margin: 0 auto;
    width: 533px;
    padding: 200px 110px;
    font-weight: 300;
}

.mdl-tabs__tab-bar {
    background-color: white;
}

.e-grid.e-wrap .e-columnmenu {
    top: 29px;
}

.mdl-layout {
    overflow: scroll;
}

#live-grid .e-columnmenu {
    display: none !important;
}

.grid-photo-icon:hover > path {
fill: #2ba259;
}

.grid-photo-icon:hover + .grid-photo-wrapper {
display: block;
}

.customtip.e-tooltip-wrap.e-popup {
    background-color: #ffffff;
    overflow: hidden;
    border: 1px solid #fff;
    border-radius: 1.5rem;
    padding: 0;
    box-shadow: 3px 3px 6px #00000050;
}

.customtip img {
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 1rem;
    overflow:hidden;
}

/* @media (max-width: 584px) {
    select,
    textarea,
    input[type="text"], */
    /* input[type="password"],
    input[type="datetime"],
    input[type="datetime-local"],
    input[type="date"],
    input[type="month"],
    input[type="time"],
    input[type="week"],
    input[type="number"],
    input[type="email"],
    input[type="url"] {
        font-size: 16px !important;
    }
}

input.e-input {
    font-size: 11px !important;
} */
